// **** import modules ****
// [moment]
import * as moment from "moment";
//import "moment/locale/ja";
moment.locale("ja");

// [jquery]
import $ from "jquery";

// [pm modules]
import { Klass, csl, u_ } from "@pressmedia/webappbase";
import "@pressmedia/webappbase-plugin-popup";
import * as google from "@pressmedia/google";

// [local modules]
import "./assets/scripts/_$.attachSmoothScroll";
import "./assets/scripts/_$.attachHoverStatus";
import "./assets/scripts/_skipLinkFocusFix";

// [components]
import siteHeader from "./components/siteHeader";
import postThumbnail from "./components/postThumbnail";
import entryMeta from "./components/entryMeta";
import siteFooter from "./components/siteFooter";
import scrollToPageTop from "./components/scrollToPageTop";
import pageHeader from "./components/pageHeader";

// **** process ****
const isProd = (NODE_ENV === "production");
csl.on("log");
if(isProd) {
	delete csl.colors.grey;
	csl._attachColors("log", false);
}
csl.on("warn");

const app = Klass.new_("WebAppBase");
app.components = {
	$window: $(window)
};

// onDocumentReady
$(() => {
	app.popup.init(app);
	
	csl.log.grey(`site version: ${PACKAGE_VERSION}`);
	csl.log.grey(`WebAppBase version: ${app._ver}`);
	
	if(	isProd &&
			u_.isObject(GCONFIG) &&
			u_.isObject(GCONFIG.analytics) &&
			GCONFIG.analytics.trackingID
	) {
		google.loadGA(GCONFIG.analytics.trackingID, true, () => {
			csl.log.blue("loadGA -- success.");
		});
	}
	
	app.components.$siteHeader = $("#site_header");
	
	// [extend body]
	app.components.$body = $(document.body).attr({
		"id": "top",
		"data-device": app.device.join("-"),
		"data-browser": app.browser.join("-"),
		"data-pixel-ratio": window.devicePixelRatio
	})
	.attachSmoothScroll(app.components.$siteHeader.outerHeight() + 45, $target => {
		csl.log.grey(
			"scrolled:",
			$target.offset().top - $.data(app.components.$body.get(0), "smoothScrollBuffer")
		);
	})
	.attachHoverStatus(app.device[0] === "sp" ? 250 : 0);
	
	const enebleCloseMenuByScroll = true;
	siteHeader.init(enebleCloseMenuByScroll);
	postThumbnail.init();
	entryMeta.comments.init();
	siteFooter.fixBottom();
	scrollToPageTop.init();
	pageHeader.init();
});

// export to window
Object.assign(window, {
	Klass,
	csl,
	app
});
